import { ExportButtonDropdown, ExportType, GlobalPeriodSelect } from '@components'

import { Checkbox, Text } from '@billy/design-system'
import { ChangeEvent, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useDownloadExportFile } from '@features/exports/hooks/useDownloadExportFile'

import { PeriodMode } from '../../../../enums/periodMode'
import { useSegment } from '../../../../hooks'
import { PeriodValue } from '../../../../types/periodValue'
import { useExportsPeriodValue } from '../../hooks/useExportsPeriodValue'
import { ExportsCard } from '../ExportsCard'

const ENTRY_JOURNAL_EXPORT_URL = 'postingJournal'

export const EntryJournal = () => {
  const { t } = useTranslation()
  const { encodedPeriodValue, period, setPeriod } = useExportsPeriodValue()
  const { downloadExportFile } = useDownloadExportFile()
  const { track } = useSegment()

  const [includeVoided, setIncludeVoided] = useState(false)

  const handleSelect = useCallback(
    (_: string, type: ExportType) => {
      downloadExportFile({
        exportUrl: ENTRY_JOURNAL_EXPORT_URL,
        type,
        queryParams: {
          includeVoided,
          ...(encodedPeriodValue && encodedPeriodValue !== PeriodMode.All ? { period: encodedPeriodValue } : {}),
        },
      })

      track('XXX - Mikkel - Exports', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        export_type: 'Entry journal',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        file_format: type,
        period: period.value,
      })
    },
    [downloadExportFile, encodedPeriodValue, includeVoided, period.value, track],
  )

  const handleChangePeriod = useCallback(
    (newPeriod: PeriodValue) => {
      setPeriod(newPeriod)
    },
    [setPeriod],
  )

  const handleCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setIncludeVoided(event.target.checked)
    },
    [setIncludeVoided],
  )

  return (
    <ExportsCard
      description={t('exports.card.entry_journal.description')}
      title={t('exports.card.entry_journal.title')}
      actionButton={
        <ExportButtonDropdown
          exportTypesToSkip={[ExportType.RegnskabBasis, ExportType.Html]}
          onSelect={handleSelect}
          variant="outlined"
          fullWidth
        />
      }
    >
      <div>
        <Text colorVariant="label" weight="medium">
          {t('exports.period')}
        </Text>
        <GlobalPeriodSelect encodedPeriod={encodedPeriodValue} onChange={handleChangePeriod} fullWidth />
      </div>
      <Checkbox checked={includeVoided} onChange={handleCheckboxChange}>
        {t('exports.include_voided_entries')}
      </Checkbox>
    </ExportsCard>
  )
}
